var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-header"},[_vm._m(0),_vm._m(1),_c('top-menu'),_c('right-info')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":require("@/assets/images/dxsz_logo.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-text"},[_c('span',{staticClass:"mr10"},[_vm._v("|")]),_vm._v("鼎信造价数据库 ")])
}]

export { render, staticRenderFns }